import './bonuragrand/style';
import FormStructure from './bonuragrand/form_structure';

export default FormStructure;